import React from 'react';
import { useTranslation } from 'react-i18next';

import Fetchable from '~/commons/components/util/Fetchable';
import Page from '../layout/Page';
import Card from '../layout/Card';

const PageLinks = () => {
  const { i18n } = useTranslation();

  return (
    <Page>
      <Card grid="lg">
        <Fetchable req={{ url: '/api/views/u?key=links' }}>
          {({ links }) => (
            <div className="row justify-content-center">
              <div className="col-12 col-xl-10 col-xxl-9">
                <div className="row justify-content-center g-5">
                  {links.map((l) => (
                    <a
                      key={l._id}
                      className="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                      href={i18n.pickLng(l.url)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ maxWidth: '225px' }}
                    >
                      <div className="position-relative">
                        <img
                          src="/assets/img/book.png"
                          alt=""
                          style={{ width: '100%' }}
                        />
                        <div
                          className={`
                          position-absolute d-flex flex-column
                          justify-content-evenly text-center
                          text-white fw-bold
                          fs-5
                        `}
                          style={{
                            top: '16%',
                            left: '21%',
                            width: '21%',
                            height: '65%',
                            transform: 'rotate(-17.5deg)',
                          }}
                        >
                          {l.display['zh-hant'].split('').map((c, i) => (
                            <span key={i} style={{ fontWeight: 'lighter' }}>{c}</span>
                          ))}
                        </div>
                      </div>
                      <h4 className="text-center mt-4 fw-bold">
                        {i18n.pickLng(l.display)}
                      </h4>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          )}
        </Fetchable>
      </Card>
    </Page>
  );
};

export default PageLinks;
